import { render } from "./component-egrul-exclude-decision-date.vue?vue&type=template&id=3820c482"
import script from "./component-egrul-exclude-decision-date.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-exclude-decision-date.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-exclude-decision-date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3820c482"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3820c482', __exports__)) {
    api.reload('3820c482', __exports__)
  }
  
  module.hot.accept("./component-egrul-exclude-decision-date.vue?vue&type=template&id=3820c482", () => {
    api.rerender('3820c482', render)
  })

}


export default __exports__